import { createSlice } from '@reduxjs/toolkit';

/**
 * Interface for Maintenance Filter state in Redux store
 */
export interface IMaintenanceFilterState {
  searchText: string;
  status: string;
  sortColumn: string;
  sortType: string;
}

const initialState: IMaintenanceFilterState = {
  searchText: '',
  status: '',
  sortColumn: 'startTimestamp',
  sortType: 'ASC'
};

const filterMaintenanceSlice = createSlice({
  name: 'filterMaintenance',
  initialState,
  reducers: {
    addFilterMaintenanceData: (state, action) => {
      state.searchText = action.payload.searchText;
      state.status = action.payload.status;
    },
    addSortMaintenanceData: (state, action) => {
      state.sortColumn = action.payload.sortColumn;
      state.sortType = action.payload.sortType;
    }
  }
});

export const {
  addFilterMaintenanceData,
  addSortMaintenanceData
} = filterMaintenanceSlice.actions;

export default filterMaintenanceSlice.reducer;
